import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/auth.js";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    message: null,
  },
  mutations: {
    setMessage(state, payload) {
      state.message = payload;
    },
    clearMessage(state) {
      state.message = null;
    },
  },
  actions: {},
  getters: {},
  modules: {
    Auth
  }
});
